export default __webpack_public_path__ + "static/media/zdh_tent_01.ade4fdf2.webp";